import { Link } from "react-router-dom";
import { useBilingual } from "@/lib/bilingual";
import { asset } from "@/lib/asset";

const AboutCTA = () => {
  const b = useBilingual();
  return (
    <section className="relative py-28 overflow-hidden bg-stone-950">
      <div className="absolute inset-0 opacity-10">
        <img
          src={asset("/editorial/about-cta-bg.jpg")}
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-stone-950/80 to-stone-950/95" />

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center gap-4 mb-8">
          <span className="block h-px w-12 bg-amber-700/50" />
          <span className="text-amber-500 text-xs font-semibold tracking-widest uppercase">
            {b("Source with Confidence", "安心採購")}
          </span>
          <span className="block h-px w-12 bg-amber-700/50" />
        </div>

        <h2
          className="text-3xl md:text-6xl font-bold text-white mb-6 leading-tight"
          style={{ fontFamily: "var(--font-display)" }}
        >
          {b("Ready to Source from Forwaro?", "準備好與 Forwaro 合作了嗎？")}
        </h2>
        <p className="text-stone-400 text-base md:text-lg max-w-xl mx-auto mb-12 leading-relaxed">
          {b(
            "Our export team is ready to provide custom quotes, product samples, and full documentation support for your market.",
            "外銷團隊可為您準備客製報價、產品樣品與完整的出口文件，協助進入您的目標市場。",
          )}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact?intent=quote"
            className="bg-amber-700 hover:bg-amber-600 text-white font-semibold px-10 py-4 rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            {b("Request a Quote", "立即詢價")}
          </Link>
          <Link
            to="/contact"
            className="border border-stone-600 hover:border-stone-400 text-stone-300 hover:text-white font-semibold px-10 py-4 rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            {b("Contact Us", "聯絡我們")}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutCTA;
